import React, { useEffect, useMemo, useState } from "react";
import "../../styles/remediation.css";
import { hasRemediationAccess } from "../../config/searchSpaces";
import { useRemediationData } from "./useRemediationData";
import CasesTable from "../diagrams/CasesTable";
import PageFeedback from "../layout/PageFeedback";

export default function RemediationPage({ searchSpace }) {
  const { loading, status, stats } = useRemediationData(searchSpace);

  const types = stats?.TYPES || [];
  const [selectedTypeName, setSelectedTypeName] = useState("");

  useEffect(() => {
    if (!selectedTypeName && types.length > 0) {
      setSelectedTypeName(types[0].TYPE_NAME);
    }
  }, [types, selectedTypeName]);

  const selectedType = useMemo(() => {
    return types.find((t) => t.TYPE_NAME === selectedTypeName) || null;
  }, [types, selectedTypeName]);

  const isOffline = stats?.AINSTEIN_STATUS === "offline";

  return (
    <div className="remediation-shell">
      <div className="remediation-main">
        <div className="remediation-inner">
          <div className="remediation-header-row">
            <h2 className="remediation-title">Remediation Data</h2>
          </div>

          {hasRemediationAccess(searchSpace) ? (
            <div className="remediation-card">
              {loading ? (
                <PageFeedback type="info">
                  Loading Remediation Data...
                </PageFeedback>
              ) : isOffline ? (
                <PageFeedback type="error">
                  {status || "Service offline"}
                </PageFeedback>
              ) : (
                <>
                  {status && <PageFeedback type="info">{status}</PageFeedback>}

                  <div>
                    <div className="remediation-types-section">
                      <h4 className="remediation-types-title">
                        Remediation Types:
                      </h4>

                      {types.length > 0 ? (
                        <div className="remediation-type-chips">
                          {types.map((type) => {
                            const isActive =
                              type.TYPE_NAME === selectedTypeName;

                            return (
                              <button
                                key={type.TYPE_NAME}
                                type="button"
                                onClick={() =>
                                  setSelectedTypeName(type.TYPE_NAME)
                                }
                                className={`remediation-type-chip ${isActive ? "is-active" : ""
                                  }`}
                              >
                                {type.TYPE_NAME}{" "}
                                (
                                {Number(type.AMOUNT || 0).toLocaleString(
                                  "de-DE"
                                )}
                                )
                              </button>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="remediation-empty">
                          No remediation types were returned by the backend.
                        </div>
                      )}
                    </div>

                    {selectedType ? (
                      <CasesTable
                        typeName={selectedType.TYPE_NAME}
                        cases={selectedType.CASES || []}
                      />
                    ) : (
                      <div className="remediation-empty">
                        Select a remediation type to view cases.
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="remediation-card remediation-card--spaced">
              <div className="remediation-empty">
                Remediation data is not available for this space.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}